import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LoaderService } from '../../_services/loader.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs/observable';
import { saveAs } from 'file-saver';

import 'rxjs/add/operator/map'
import { networkInterfaces } from 'os';

declare var $: any;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'cmp-pcts',
  templateUrl: './pcts.component.html',
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class PctsComponent {

  @ViewChild('table') table: ElementRef;
  page = 1;
  public prjId: any
  public userId: any
  public startDate: any
  public endDate: any
  public defaultStartDate: any
  public defaultEndDate: any
  public dataRangeModal: any
  public showLoader: boolean
  public disFuelReport: any
  public pctsDataNotFound = false
  public search: any;
  syncing: any
  public selectedRow: Number;
  loaderClass: any;
  perColor: string;
  perBg: string;
  pctsReport: any;
  tonCent: number;
  public date = moment();

  low: boolean;
  medium: boolean;
  high: boolean;

  constructor(private http: HttpClient, private auth: AuthService, public routes: ActivatedRoute, public router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    var date = new Date();
    this.defaultStartDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.dataRangeModal = { beginDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };
  }

  getData() {
    // this.http.get("./mock.json").map(data => data.json() as Array<Item>).subscribe(data => {
    //     this.items = data;
    //     console.log(data);
    //   });
    var date = moment(this.date).format('YYYY-MM-DD')
    this.http.get(environment.apiUrl + 'reports/getPCTSReport?date=' + date).subscribe(data => {
      this.pctsReport = data;
      console.log("items", this.pctsReport);

      var netWt
      for (var i = 0; i < this.pctsReport.length; i++) {
        var wbWt = (this.pctsReport[i].DB_WT)
        var tsWt = this.pctsReport[i].PCTS_WT
        if (tsWt == "") {
          netWt = wbWt
        }
        else if (wbWt == "") {
          netWt = tsWt
        }
        else {
          netWt = wbWt - tsWt
          var wtPercentage = (tsWt / wbWt) * 100
          var wtPer = wtPercentage.toFixed(0)
          var wtPerInt = parseInt(wtPer, 10)
          this.pctsReport[i].percent = wtPerInt
          var wtPerIntCode;
          if(wtPerInt <= 33){
            wtPerIntCode = 'low'
          }
          else if (wtPerInt > 33 && wtPerInt <= 66){
            wtPerIntCode = 'medium'
          }
          else if (wtPerInt > 66 && wtPerInt <= 100){
            wtPerIntCode = 'good'
          }
          else if (wtPerInt > 100){
            wtPerIntCode = 'excelent'
          }
          else {
            wtPerIntCode = null
          }
          this.pctsReport[i].percentCode = wtPerIntCode          
        }
      }
      console.log(this.pctsReport);
    });
  }

  dateChanged() {
    console.log('fsdjhfdskhfksdhfsdhf');
    this.getData();
  }

  getPercentage(data) {
  }

  /*
    * Get VEHICLE HISTORY DEATILS 
    */
  getVtsDailyReport() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'reports/getDistanceFuelReport?prjId=' + this.prjId + "&startDate=" + this.startDate + "&endDate=" + this.endDate).subscribe(data => {
      this.disFuelReport = data;
      // console.log(this.disFuelReport);
      if (this.disFuelReport.length > 0) {
        this.loaderService.display(false);
        this.pctsDataNotFound = true
      } else {
        this.loaderService.display(false);
        this.pctsDataNotFound = false
      }
    },
      error => {
        this.loaderService.display(false);
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again',
        })
      });
  }

  /*
    *select start Date Nad To date
    */
  onDateRangeChanged(dataRange) {
    if (dataRange.beginDate.day > 0) {
      this.startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
      this.endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
      this.getVtsDailyReport();
    }
    else if (dataRange.beginDate.day == 0) {
      this.startDate = this.defaultStartDate
      this.endDate = this.defaultEndDate
      this.getVtsDailyReport();
    }
  }

  /*
      * This Method Is use to Download the Vehicles Report into Excel File 
      */


  importVtsDailyReport() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'DistanceFuelReport.xlsx');
  }


  /*
   * Get Index and Select Table Row
   */
  selectRowIndex(data, index) {
    this.selectedRow = index;
  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
    this.getVtsDailyReport();
    this.getData();
    this.getPercentage(this.pctsReport);
    this.syncing = false
    this.loaderClass = 'fas fa-sync'
    this.dateChanged()
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/plant/pcts.component.ts